import useJwt from '@/auth/jwt/useJwt'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

export async function gerarRelatorioProposta(vueInstance, htmlContent, nomeRelatorio) {
  if (typeof vueInstance.sweetAlert === 'function') {
    vueInstance.sweetAlert(true)
  } else {
    Swal.fire({
      title: 'Carregando...',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      },
    })
  }

  const style = `
  <head>
  <meta name="viewport" content="width=device-width,initial-scale=1,shrink-to-fit=no">
    <link type="text/css" rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" />
    <link type="text/css" rel="stylesheet" href="https://unpkg.com/bootstrap-vue@latest/dist/bootstrap-vue.min.css">

  <script src="https://polyfill.io/v3/polyfill.min.js?features=es2015%2CIntersectionObserver"
  crossorigin="anonymous"></script>
  <script src="https://unpkg.com/vue@latest/dist/vue.min.js"></script>
  <script src="https://unpkg.com/bootstrap-vue@latest/dist/bootstrap-vue.min.js"></script>
  <script src="https://unpkg.com/bootstrap-vue@latest/dist/bootstrap-vue-icons.min.js"></script>

  <link rel="stylesheet" type="text/css" href="<%= BASE_URL %>loader.css" />
  <link rel="icon" href="<%= BASE_URL %>favicon.ico" />
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;1,400&display=swap"
    rel="stylesheet" />

    <style>
            .fundoRelatorio {
            background-color: white;
            word-break: break-word;
        }


        .lineBlue {
            width: 288px;
            height: 13px;
            background-color: #4941a6;
        }

        .lineGray {
            width: 563px;
            height: 13px;
            background-color: #b8c2cb;
        }

        .cabecalhoTable {
            margin-bottom: 0px;
            font-size: 12px;
            word-wrap: normal;
            white-space: pre-wrap;
        }

        .bold-footer-row {
            font-weight: bold;
        }

        div.vue-html2pdf div.card-body {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }

        div, p, h1, h4 {
            color: #696d70 !important;
        }

        .table td, .table th {
            padding: .6rem;

        }
    </style>
</head>
  `

  const fullHtmlContent = `
    <!DOCTYPE html>
    <html lang="pt-br">
       ${style}
      <body>
       ${htmlContent}
      </body>
    </html>
  `

  try {
    const response = await useJwt.post(
      'relatorio/getRelatorioProposta',
      {
        htmlContent: fullHtmlContent,
        nomeRelatorio,
      },
      { responseType: 'blob' },
    )
    handlePdfResponse(response.data, vueInstance)
  } catch (error) {
    if (typeof vueInstance.sweetAlert === 'function') {
      vueInstance.sweetAlert(false)
    } else {
      Swal.close()
    }
  }
}

function handlePdfResponse(pdfData, vueInstance) {
  try {
    const blob = new Blob([pdfData], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'relatorio.pdf')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    if (typeof vueInstance.sweetAlert === 'function') {
      vueInstance.sweetAlert(false)
    } else {
      Swal.close()
    }
  } catch (error) {
    console.error('Erro ao gerar PDF:', error)
    if (typeof vueInstance.sweetAlert === 'function') {
      vueInstance.sweetAlert(false)
    } else {
      Swal.close()
    }
  }
}
